import {combineReducers, Dispatch, Action, AnyAction} from "redux";
import {connectRouter} from "connected-react-router";
import {History} from "history";

import {tagReducer} from "@reducers/tag";
import {packageReducer} from "@reducers/package";
import {supplierReducer} from "@reducers/supplier"
import {categoryReducer} from "@reducers/category";
import {peopleReducer} from "@reducers/people";
import {imageReducer} from "@reducers/image";
import {personRoleReducer} from "@reducers/person-roles";
import {userRoleReducer} from "@reducers/user-roles";
import {resourcesReducer} from "@reducers/resources";
import {menuReducer} from "@reducers/menu";
import {provinceReducer} from "@reducers/province";
import {cityReducer} from "@reducers/city";
import {videoContentReducer} from "@reducers/videoContent";
import {videoFileReducer} from "@reducers/videoFile";
import {widgetReducer} from "@reducers/widget";
import {userReducer} from "@reducers/user";
import {jobReducer} from "@reducers/job";
import {clientReducer} from "@reducers/client";
import {quizReducer} from "@reducers/quiz";
import {authReducer} from "@reducers/auth";
import {hyperLinkMenuReducer} from "@reducers/hyperLinkMenu";
import {commentsReducer} from "@reducers/comments";
import {aliasReducer} from "@reducers/alias";
import {ticketReducer} from "@reducers/ticket";
import {draftsPeopleReducer} from "@reducers/draftsPeople";
import {trackerPolicyReducer} from "@reducers/trackerPolicy";
import {errorReducer} from "@reducers/error";


import {TagsState} from "@models/tag";
import {PackagesState} from "@models/package";
import {SupplierState} from "@models/supplier"
import {CategoriesState} from "@models/category";
import {PeopleState} from "@models/person";
import {ImagesState} from "@models/image";
import {PersonRolesState} from "@models/person-role";
import {UserRolesState} from "@models/user-role";
import {ResourcesState} from "@models/resource";
import {MenuState} from "@models/menu";
import {VideoContentsState} from "@models/video-content";
import {VideoFilesState} from "@models/video-file";
import {WidgetsState} from "@models/widget";
import {UsersState} from "@models/user";
import {AuthState} from "@models/auth";
import {ProvinceState} from "@models/province";
import {CityState} from "@models/city";
import {JobState} from "@models/job";
import {ClientState} from "@models/client";
import {QuizState} from "@models/quiz";
import {HyperLinkMenusState} from "@models/hyperLinkMenu";
import {CommentState} from "@models/comment";
import {AliasState} from "@models/alias";
import {TicketState} from "@models/ticket";
import {DraftPeopleState} from "@models/draftPeople";
import {TrackerPolicyState} from "@models/trackerPolicy";
import {ErrorState} from "@models/axios";

// The top-level state object
export interface ApplicationState {
  tags: TagsState;
  packages : PackagesState;
  supplier :SupplierState;
  categories: CategoriesState;
  people: PeopleState;
  images: ImagesState;
  personRoles: PersonRolesState;
  userRoles: UserRolesState;
  resources: ResourcesState,
  menus: MenuState;
  videoContents: VideoContentsState;
  videoFiles: VideoFilesState;
  widgets: WidgetsState;
  users: UsersState;
  auth: AuthState;
  provinces: ProvinceState;
  cities: CityState;
  jobs: JobState;
  quizzes: QuizState;
  hyperLinkMenus: HyperLinkMenusState;
  comments: CommentState;
  aliases: AliasState;
  tickets: TicketState;
  draftsPeople: DraftPeopleState;
  trackerPolicy: TrackerPolicyState;
  error: ErrorState,
  
}

// Additional props for connected React components. This prop is passed by default with `connect()`
export interface ConnectedReduxProps<A extends Action = AnyAction> {
  dispatch: Dispatch<A>;
}

export const createRootReducer = (history: History) =>
  combineReducers({
    categories: categoryReducer,
    tags: tagReducer,
    packages: packageReducer,
    supplier:supplierReducer,
    people: peopleReducer,
    images: imageReducer,
    personRoles: personRoleReducer,
    userRoles: userRoleReducer,
    resources: resourcesReducer,
    menus: menuReducer,
    videoContents: videoContentReducer,
    videoFiles: videoFileReducer,
    widgets: widgetReducer,
    users: userReducer,
    auth: authReducer,
    provinces: provinceReducer,
    cities: cityReducer,
    jobs: jobReducer,
    clients: clientReducer,
    hyperLinkMenus: hyperLinkMenuReducer,
    comments: commentsReducer,
    aliases: aliasReducer,
    tickets: ticketReducer,
    draftsPeople: draftsPeopleReducer,
    trackerPolicy: trackerPolicyReducer,
    quizzes: quizReducer,
    error: errorReducer,
    router: connectRouter(history)
  });
